import { EventEmitter, Injectable, Output } from "@angular/core";
import { HubConnection, HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import { Subject, Observable, BehaviorSubject } from "rxjs";
import { environment } from "src/environments/environment";
import { MapService } from "./Map.service";
import { NotificationsToastService } from "./Notifications-Toast.service";
import { AzureBotService } from "../features/azure-bot/services/AzureBot.service";

@Injectable({
  providedIn: "root",
})
export class SignalRService {
  public signalConnection: HubConnection;
  public ConnectionId: string;
  // BehaviorSubject to emit connection id changes; start as null until a value is available
  private connectionIdSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
  public connectionId$: Observable<string | null> = this.connectionIdSubject.asObservable();
  $dataGeoJson: any;
  incommingsConfigUrl: any;
  onUpdateLocationActive$: Subject<string> = new Subject<string>();

  constructor(private notificationsToastService: NotificationsToastService, private AzureBotService: AzureBotService) {
    this.incommingsConfigUrl = environment.signalRHost;
  }

  public startConnection() : any {
    this.signalConnection = new HubConnectionBuilder()
      .withUrl(this.incommingsConfigUrl + "/Signal")
      .withAutomaticReconnect()
      .configureLogging(LogLevel.None)
      .build();
    // log reconnect events and ensure listeners / connection id are refreshed on reconnect
    this.signalConnection.onreconnected((connectionId) => {
      console.log('SignalR reconnected, connectionId (server):', connectionId);
      // refresh server-side assigned connection id and re-register listeners if needed
      this.getConnectionId();
    });

    this.signalConnection.onreconnecting((error) => {
      console.warn('SignalR reconnecting...', error);
    });

    this.signalConnection.onclose((error) => {
      console.warn('SignalR connection closed', error);
    });

    this.signalConnection
      .start()
      .then(() => {
        console.log("Connection Started");
        // After the connection is started, get the ConnectionId and register listeners.
        this.getConnectionId();
        try {
          this.TestListener();
        } catch (e) {
          console.error('Error registering TestListener after start:', e);
        }
      })
      .catch((err) => {
        console.log("Error while starting connection: " + err);
        // Let automatic reconnect handle retry; do not recursively call start() immediately.
      });
  };

  public endConnection() : any {
    this.signalConnection
      .stop()
      .then(() => {
        console.log("Connection Ended");
      })
      .catch((err) => {
        console.log("Error while ending connection: " + err);
        //Intent reconnect again
        this.signalConnection.stop();
      });
  };

  private getConnectionId() :any{
    this.signalConnection.invoke("GetConnectionId").then((data) => {
      console.log("Connection Id: " + data);
      this.ConnectionId = data;
      // emit the new connection id
      this.connectionIdSubject.next(this.ConnectionId);
      return this.ConnectionId;
    });
  }

  //accion de nueva posicion de un vehiculo
  public ActivateListenerUpdateLocationActive () : any {
    this.signalConnection.on("UpdateLocationActive", (data) => {
      console.log("Mensaje SIGNAL RECIBIDO *****************,"+data);
      this.setOnUpdateLocationActive(data);
    });
  };

  //accion de nueva notificación, activa toasts
  public ActivateListenerNewNotification () : any {
    this.signalConnection.on("NewNotification", (data) => {
      var notificationDTO = JSON.parse(data);
      
      console.log("Notificación SIGNAL RECIBIDA *****************,"+notificationDTO, data);
      this.notificationsToastService.showCustomToast(notificationDTO);
    });
  };

  //accion de asignación
  public ActivateListenerAssignment () : any {
    this.signalConnection.on("Assignment", (data) => {
      var assignmentDTO = JSON.parse(data);

      console.log("Asignación SIGNAL RECIBIDA *****************,"+assignmentDTO, data);
      this.notificationsToastService.showCustomToast(assignmentDTO);
    });
  };

   public TestListener () : any {
    if (!this.signalConnection) {
      console.warn('TestListener called but signalConnection is not initialized yet');
      return;
    }

    console.log('Registering TestListener for TestSignalMessage');
    this.signalConnection.on("TestSignalMessage", (data) => {
      let assignmentDTO: any = data;
      try {
        // Accept both already-parsed objects and JSON strings
        if (typeof data === 'string') {
          assignmentDTO = JSON.parse(data);
        }
      } catch (err) {
        console.warn('Failed to parse TestSignalMessage payload as JSON, using raw data', err);
        assignmentDTO = data;
      }

      console.log("SEÑAL RECIBIDA *****************", assignmentDTO, data);
      try {
        this.notificationsToastService.showCustomToast(data);
      } catch (e) {
        console.error('Error handling TestSignalMessage payload', e);
      }
    });
  };

  //acciones del bot
  public ActivateListenerChatBot () : any {
    this.signalConnection.on("ChatBotAction", (data) => {
      console.log("Mensaje SIGNAL RECIBIDO *****************,"+data);
      this.AzureBotService.startAction(data);
    });
  };

  public getOnUpdateLocationActive(): Observable<string>{
    return this.onUpdateLocationActive$.asObservable();
  }

  public setOnUpdateLocationActive(data): any{
    return this.onUpdateLocationActive$.next(data);
  }
}
